import {
  pathogenicVeryStrongColor,
  pathogenicStrongColor,
  pathogenicModerateColor,
  pathogenicSupportingColor,
  benignVeryStrongColor,
  benignStrongColor,
  benignModerateColor,
  benignSupportingColor,
  defaultPathogenicityColor,
  uncertainSignificanceColor,
} from "../../../../../../common/helpers/colors";

const COLORS_BASED_ON_INSILICO_PATHOGENICITY = {
  null: "#818a91",
  "Pathogenic Very Strong": pathogenicVeryStrongColor,
  "Pathogenic Strong": pathogenicStrongColor,
  "Pathogenic Moderate": pathogenicModerateColor,
  "Pathogenic Supporting": pathogenicSupportingColor,
  "Benign Supporting": benignSupportingColor,
  "Benign Moderate": benignModerateColor,
  "Benign Strong": benignStrongColor,
  "Benign Very Strong": benignVeryStrongColor,
  Uncertain: uncertainSignificanceColor,
};

export const calculateScoresColorsBasedOnPathogenicity = (
  detailedPathogenicity
) => {
  return !Array.isArray(detailedPathogenicity) ||
    detailedPathogenicity.length === 0
    ? []
    : detailedPathogenicity.map(
        (pathogenicity) =>
          COLORS_BASED_ON_INSILICO_PATHOGENICITY[pathogenicity] ||
          defaultPathogenicityColor
      );
};

export const getColorBasedOnPathogenicity = (pathogenicity) => {
  return (
    COLORS_BASED_ON_INSILICO_PATHOGENICITY[pathogenicity] ||
    defaultPathogenicityColor
  );
};
